/**
 * OIMS v2 - Configuration constants
 * Cognito settings and API base URL
 */

export const API_BASE = window.location.origin;
export const COGNITO_DOMAIN = "https://oims.auth.us-east-1.amazoncognito.com";
export const COGNITO_CLIENT_ID = "5t9jk3j9trnu94cvjacsqtakis";
export const COGNITO_REDIRECT_URI = window.location.origin + "/ui";
export const COGNITO_SCOPES = "email openid profile aws.cognito.signin.user.admin";
